import React from 'react';
import { Pie } from 'react-chartjs-2';


function PieChart(props) {
    let labels = []
    let values = []
    let color = [`rgba(10, 45, 68)`, `rgba(0, 185, 181)`, "#58585A", '#742f68', '#6190CB', '#c95f95', '#32BA8B']

    if (props.data) {
        props.data.length && props.data.forEach(element => {
            labels.push(element.containermode);
            values.push(element.total);
        });
    }


    const data = {
        labels: labels,
        datasets: [
            {
                data: values,
                backgroundColor: color
            },
        ],
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'right',
            align: 'start',
            labels: {
                usePointStyle: true,
                pointStyle: 'circle'
            }

        }
    }

    return (
        <Pie data={data} options={options} />
    )
}

export default React.memo(PieChart)
